import { useEffect, useState } from "react";
import { ContenedorPageTemplate } from "../../../components/templates/ContenedorPageTemplate";
import { TITULO_PROGRAMA_LIST, } from "../../../utils/constantes";
import { getAllProgramas } from "../../../services/programa.service";
import { ProgramaList } from "../../../modules/programa/ProgramaList";

export const ProgramaPage = () => {
  const [busqueda, setBusqueda] = useState("");
  const [programas, setProgramas] = useState(null);
  const DIR_ICON_MAT = "img/iconos/titulo de docente (con la pizarra).svg";
  useEffect(() => {
    obtenerProgramas();
  }, []);

  const obtenerProgramas = async () => {
    await getAllProgramas()
      .then((programas) => setProgramas(programas))
      .catch((err) => console.log(err));
  };

  const handleDelete = (idPrograma) => {
    setProgramas((prevProgramas) =>
      prevProgramas.filter((pro) => pro.idPrograma !== idPrograma)
    );
  };

  const programasFiltrados = programas?.filter((programa) => {
    const texto = busqueda.toLowerCase();

    const nombre = programa?.nombre?.toString().toLowerCase() || "";
    const duracion = programa?.duracion?.toString().toLowerCase() || "";
    const totalPrecio = programa?.totalPrecio?.toString().toLowerCase() || "";

    return (
      nombre.includes(texto) ||
      duracion.includes(texto) ||
      totalPrecio.includes(texto)
    );
  });


  return (
    <ContenedorPageTemplate objetos={programas}
      dirIcono={DIR_ICON_MAT}
      titulo={TITULO_PROGRAMA_LIST}
    >
      <div className="flex flex-col justify-start items-start">
        <p>
          Total de estudiantes: <span>{programasFiltrados?.length}</span>
        </p>
      </div>
      <div className="flex gap-4 py-3">
        <input
          type="text"
          placeholder="Buscar por nombre, duración o costo..."
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
          className="flex-1 text-black border shadow-sm rounded-xl py-3 px-4 focus:ring-1 focus:border-blue-500 focus:ring-blue-300 transition-colors hover:border-blue-500 border-slate-200"
        />
      </div>
      <ProgramaList programas={programasFiltrados} onDelete={handleDelete} />
    </ContenedorPageTemplate>
  );
};
